import React, { useState } from "react";
import { config } from "../config/config";
import ActividadForm from "../components/ActividadForm";
import ActividadList from "../components/ActividadList";
import showAlert from '../components/Alert';
import showConfirm from "../components/ConfirmAlert";

const Actividades = () => {
    const [editingActividad, setEditingActividad] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(false); // Estado para gestionar la recarga
    const [resetForm, setResetForm] = useState(false);

    // Función para recargar la lista de actividades
    const reloadActividadList = () => {
        setReloadTrigger(!reloadTrigger); // Cambiar el valor para activar la recarga
    };

    // Función para crear o actualizar una actividad
    const handleCreateOrUpdate = (actividad) => {
        const url = editingActividad
            ? `${config.apiUrl}/actividades/${editingActividad.actividad_id}`
            : `${config.apiUrl}/actividades`;
        const method = editingActividad ? "PUT" : "POST";

        fetch(url, {
            method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(actividad),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Error al guardar la información");
                }
                return response.json();
            })
            .then(() => {
                showAlert(editingActividad, "Actividad");
                setEditingActividad(null); // Limpiar la actividad en edición
                setResetForm(true); // Resetear el formulario
                reloadActividadList(); // Recargar la lista después de guardar
            })
            .catch(console.error);
    };

    // Función para eliminar una actividad
    const handleDelete = async (id) => {
        const isConfirmed = await showConfirm();
        if (isConfirmed) {
            fetch(`${config.apiUrl}/actividades/${id}`, { method: "DELETE" })
                .then(() => {
                    console.log("Actividad eliminada");
                    reloadActividadList(); // Recargar la lista después de eliminar
                })
                .catch(console.error);
        }
    };

    return (
        <div>
            {/* Formulario para crear o editar actividades */}
            <ActividadForm
                onSubmit={handleCreateOrUpdate}
                initialData={editingActividad}
                resetForm={resetForm}
            />

            {/* Lista de actividades */}
            <ActividadList
                onEdit={(actividad) => setEditingActividad(actividad)}
                onDelete={handleDelete}
                reloadTrigger={reloadTrigger} // Pasamos reloadTrigger a ActividadList
            />
        </div>
    );
};

export default Actividades;